module.exports = __webpack_public_path__ + "img/icon_offline.c0bc5a2c.svg";